module.exports = __webpack_public_path__ + "static/media/zhanghaodenglu.ac166dc8.png";